<div class="dialogContainer">
  <div class="header">
    <h2>Please Enter Serial Number</h2>
  </div>
  <div class="content">
    @if (errorMessage) {
      <div class="errorMessage">
        {{errorMessage}}
      </div>
    }
    <div class="tableContainer">
      <table class="partTable">
        <thead>
          <tr>
            <td class="headerCell tableCell">Part #</td>
            <td class="headerCell tableCell">SerialNumber</td>
          </tr>
        </thead>
        @for (part of filteredParts; track part) {
          <tr>
            <td class="tableCell">{{part.partNumber}}</td>
            <td class="tableCell"><input class="serialNumberInput" [(ngModel)]="part.serialNumber" /></td>
          </tr>
        }
      </table>
    </div>
  </div>
  @if (isBusy) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button class="warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
      <button class="primary-button" matButton="elevated" (click)="saveAndClose()">Save</button>
    </span>
  </div>
</div>